const requireModule = require.context('./', false, /.js$/);
const modules = requireModule.keys().filter(path => path !== './index.js').map(path => requireModule(path).default);

export default {
  modules: _.reduce(modules, (acc, mod) => ({ ...acc, ...mod.store }), {}),
  plugins: modules.map(mod => mod.plugin),
};
